export default "__VITE_ASSET__ClKKFe5___"